import { v4 as uuidv4 } from 'uuid'

const ART_COLLECTION_NAV = [
  {
    id: uuidv4(),
    navTitleTx: 'collections-and-research:navs.collections',
    href: {
      tr: '/collections-and-research/collections',
      en: '/collections-and-research/collections',
    },
  },
  {
    id: uuidv4(),
    navTitleTx: 'collections-and-research:navs.archives',
    href: {
      tr: '/collections-and-research/archives',
      en: '/collections-and-research/archives',
    },
  },
  {
    id: uuidv4(),
    navTitleTx: 'collections-and-research:navs.artists',
    href: {
      tr: '/artist/a-z/a',
      en: '/artist/a-z/a',
    },
  },
  {
    id: uuidv4(),
    navTitleTx: 'collections-and-research:navs.conservation',
    href: {
      tr: '/koleksiyonlar-ve-arastirmalar/konservasyon',
      en: '/collections-and-research/conservation',
    },
  },
  {
    id: uuidv4(),
    navTitleTx: 'collections-and-research:navs.digitalSSM',
    href: {
      tr: 'https://digitalssm.org',
      en: 'https://digitalssm.org',
    },
    isExternal: true,
  },
]

export default ART_COLLECTION_NAV
